const {
  LOGIN_USER_SUCCESS,
  LOGIN_NOTIFICATION,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  VERIFY_RESET_LINK
} = require("../constants");

const initialState = {
  loginNotification: {
    message: "",
    isSuccess: 1,
  },
  login_data: {},
  register_data: {},
  forgot_data: {},
  verify_data: {},
  reset_data: {},
  verification_data: {},
  guest_user_data: {},
  reset_data: {},
  reset_verification_data: {},
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGIN_NOTIFICATION:
      return {
        ...state,
        loginNotification: payload.message
          ? payload
          : initialState.loginNotification,
      };

    case LOGIN_USER_SUCCESS: {
      return {
        ...state,
        login_data: payload,
      };
    }

    case FORGOT_PASSWORD:{
      return {
        ...state,
        forgot_data: payload,
      };
    }

    case RESET_PASSWORD: {
      return {
        ...state,
        reset_data: payload,
      };
    }

    case VERIFY_RESET_LINK: {
      return {
        ...state,
        reset_verification_data: payload,
      };
    }

    default:
      return state;
  }
};

export default reducer;
